import { gql } from '@apollo/client';

const getLetterTemplates = gql`
  query getLetterTemplates($search: String) {
    getLetterTemplates(search: $search) {
      id
      name
      description
      content
      variables_used
      created_by
      created_at
      updated_at
      is_active
    }
  }
`;

export default getLetterTemplates;
